export const jobs = [
    {
        employer: 'Arche Biotechnolgies @ Hamilton, On',
        title: 'Software Engineering Intern',
        link: 'https://www.linkedin.com/company/arche-biotechnologies-inc/',
        desc: 'At an emerging biomedical start-up, I am working with a team to develop a Web-App to interface with Arche’s custom sensors. Using React, Mongo-DB, Express.js, and Node.js, I have been tasked with designing and improving the infrastructure of the application, where I work with real-time data processing, storage, retrieval, and communication.',
        date: 'April 2024 - Present',
        skills:['React.js', 'Express.js', 'MongoDB', 'Node.js']
    },
    {
        employer: 'McMaster University',
        title: 'Teaching Assistant',
        link: 'https://www.eng.mcmaster.ca/ibiomed/courses/',
        desc:'After taking the course only a few months prior, I was offered a position as a Teaching Assistant for IBEHS 1P10: Health Solution Design Projects. I teach a group of ~30 (amazing) students and lead discussions as they build multi-week projects. As a TA, I encourage effective team communication, aid with ideation, help debug, and explain the correct engineering design process. Additionally, I help teach the logic and syntax behind fundamental Python principles, such as conditional statements, loops, file I/O and OOP.',        date: 'September 2024 - Present',
        skills: ['Python', 'OOP', 'Communcation', 'Leadership']
    },
    {
        employer: 'Biomedic.ai Labs @ McMaster University',
        title: 'AI/ML Research Assistant & Full Stack Developer Intern',
        link: 'http://www.mcmaster.ai',
        desc: "After being awarded the National Sciences and Engineering Research Council’s Undergraduate Student Research Award, I pursued this opportunity at Biomedic.AI Labs at McMaster. I had been assigned to two different projects. First, I worked towards achieving an artificial intelligence model to predict surgical intention. With the ultimate goal of AI becoming a more active partner within the healthcare field, this model would be able to accelerate the rate at which surgeons are trained and act as surgical assistants within the operating room. Later, I contributed to a full-stack engineering project for a web app that utilizes the MERN stack to asses the quality of machine learning used within research papers within the industry.",
        date: 'May 2024 - August 2024',
        skills:['Python', 'TensorFlow', 'AI Theory', 'MERN Stack']
    },
    {
        employer: 'Heuvelmans Chevrolet Buick GMC Cadillac Ltd.',
        title: 'Office Assistant',
        link: 'http://www.Heuvelmanschev.ca',
        desc: 'Developed and implemented storage systems to store financial documents, maintained these organizational systems for efficient retrieval. Worked as a night receptionist, communicating with 30+ customers per hour and creating a positive client experience.',
        date: 'July 2022 - August 2023',
        skills: ['Communication', 'Organization', 'Outgoing']
    }
]

export const proj1 = [
    {
        Title: 'HackMe',
        image: 'project_pics/hackMe_pic.jpg',
        date: 'November 2024',
        desc: '1ST PLACE WINNER @ McMaster Engineering Competition. HackMe is an automated cybersecurity diagnostician. After being given a cyber security prompt, we automated a series of cyber-attacks to expose vulnerabilities in websites/web applications, and automatically serve clients with a cybersecurity report complete with all found vulnerabilities, the risks associated with them, and future steps to avoid a data breach. HackMe: find your pain points.',
        link: 'https://github.com/shadielfares/Bravo',
        skills: ['ReactJS', 'Flask', 'Javascript', 'Python']

    },
    {
        Title: 'Dash-Tab',
        image: 'project_pics/dashTab_pic.jpg',
        date: 'September 2024',
        desc: 'Dash-Tab is a chrome extension that transforms your new-tab screen. Rather than wasting valuable screen real estate, leave reminders and notes for yourself! Also, use focus mode to become even more productive. Using sustainable database architecture that already withstands 29 000+ monthly retrievals, Dash-Tab has become a staple in many people’s productivity workflow.',
        link: 'https://github.com/ahmed-z5645/Dash-Tab',
        skills: ['ReactJS', 'Firebase', 'JavaScript', 'Chrome']
    }
]

export const proj2 = [
    {
        Title: 'IBEHS Design Project IV: RehabiliMate',
        image: 'project_pics/rehabilimate_pic.jpg',
        date: 'April 2024',
        desc: 'PRESENTED AT ANNUAL iBIOMED SHOWCASE (8/45 projects present). RehabiliMate was designed for a community partern we interviewed. Collectively, discovered our client, affected by Multiple Sclerosis, had lost mobility/function in her left hand. Our mission was to build a device that aided in her rehabilitation in a fun and maintainable way.',
        link: 'https://ahmed-zafar.notion.site/DP-4-RehabiliMate-12f7dab72f7c4ceabd700a2fffd46389',
        skills: ['Raspberry Pi', 'Gamification', 'Problem Identification', 'Python']
    },
    {
        Title: 'IBEHS Design Project III: PillPal',
        image: 'project_pics/pill_Pal_pic.png',
        date: 'February 2024',
        desc: 'PillPal was created as a way to support nursing homes, and those with neurodegenerative diseases who may be experienceing memory loss. By interfacing a time-of-flight distance sensor and a python GUI, we were able to create a pill dispenser with user authentication and personalized dispensing times and amounts.',
        link: 'https://ahmed-zafar.notion.site/DP-3-PillPal-c1ef2e4628b142cba136aaca579965eb',
        skills: ['Raspberry Pi', 'Figma', 'Custom Tkinter']
    }
]

export const proj3 = [
    {
        Title: 'Machine Learning Risk Assessment Device',
        image: 'project_pics/mLRAD_pic.jpg',
        date: 'March 2024',
        desc: '3RD PLACE WINNER @ University of Toronto X McMaster Designathon. Machine Learning Risk Assessment Device, or ML-RAD, uses computer vision and neural networks to identify high-risk objects that may be a threat for our community partner who suffered a stroke and was left with left-side neglect.',
        link: 'https://www.linkedin.com/feed/update/urn:li:activity:7180580905365774336/',
        skills: ['TensorFlow', 'openCV', 'Presenting']

    }
]

export const logos1 = [
    {
        image: 'logoSVGs/github.svg',
        link: 'https://github.com/ahmed-z5645'
    },
    {
        image: 'logoSVGs/linkedin.svg',
        link: 'https://www.linkedin.com/in/ahmed-zafarmcmaster'
    }
]

export const logos2=[
    {
        image: 'logoSVGs/gmail.svg',
        link: 'mailto:ahmed.zafar5645@gmail.com'
    },
    {
        image: 'logoSVGs/instagram.svg',
        link: 'https://www.instagram.com/_ahmedzafar_/'
    }
]